export function localizeInCityToken(text: string, localizedCity?: string | null) {
  if (!text.includes('{{inCity}}')) return text;

  // Replace token with city
  if (localizedCity) {
    return text.replace('{{inCity}}', localizedCity);
  }

  // Remove token + punctuation when no city exists
  const cleaned = text.replace(/\{\{inCity\}\},\s*/g, '').replace(/\{\{inCity\}\}\s*/g, '');

  // Capitalize first actual letter
  return cleaned.replace(/^\s*[a-z]/, (match) => match.toUpperCase());
}
